<template>
		<div class="test-detail">
			<div class="back" @click="goBack"><img src="../assets/icon／arrow-right@2x.png"> 返回 </div>
			<div class="test-main">
				<div class="test-info">
					<div class="point-label">{{$route.query.point_name}}</div>
<!-- 					<div class="point">
						<div>本题知识点：</div>
						<div class="point-name">{{$route.query.point_info}}</div>
					</div> -->
					<div class="point-num">
						<div>正确率：</div>
						<div class="num">{{calculateAccuracy()}}</div>
					</div>
					<div class="point-info">
						<div class="point-info-label"></div>
						<div class="point-info-text">{{$route.query.point_info||$route.query.point_name}}</div>
					</div>
					<div class="point-list">
						<div class="point-item"
						 :class="{
						 		'point-item-t': item.bingo==1,
						 		'point-item-f': item.bingo==2,
								'point-item-act': act == index,
						 	}"
							@click="checkTi(index)"
							v-for="(item,index) in testDetailList" :key="index">{{index+1}}</div>
					</div>
					<div class="point-legend">
						<div class="point-legend-cont">
							<div class="point-legend-icon point-legend-icon-no"></div>
							<div>未答</div>
						</div>
						<div class="point-legend-cont">
							<div class="point-legend-icon point-legend-icon-t"></div>
							<div>正确</div>
						</div>
						<div class="point-legend-cont">
							<div class="point-legend-icon point-legend-icon-f"></div>
							<div>错误</div>
						</div>
					</div>
				</div>
				<div class="test-list" v-if="testDetailList[act]">
					<div class="question" v-if="testDetailList[act]">
						<span>{{act+1}}.</span>
						<MarkdownMath :content="testDetailList[act].name"></MarkdownMath>
					</div>
					<div class="answer-list" v-if="!testDetailList[act].bingo">
						<template v-if="testDetailList[act]">
							<div class="answer-item" v-for="(item,index) in testDetailList[act].answer_list" @click="checkItem(item)" :key="index">
								<div class="answer-icon" :class="item.check?'answer-icon-act':''"></div>
								<div class="answer-text">
									<span>{{abcd(index)}}.</span>
									<MarkdownMath :content="item.label"></MarkdownMath>
								</div>
							</div>
						</template>
					</div>
					<div class="answer-list" v-else>
						<div class="answer-item" v-for="(item,index) in testDetailList[act].answer_list":key="index">
							<div class="answer-icon"  :class="{
									'answer-icon-true': item.check&&item.isAnswer,
									'answer-icon-false': item.check&&!item.isAnswer
								}">
							</div>
							<div class="answer-text">
								<span>{{abcd(index)}}.</span>
								<MarkdownMath :content="item.label"></MarkdownMath>
							</div>
						</div>
					</div>
					<div class="btn-group">
						<div v-if="!testDetailList[act].bingo" @click="submit" class="submit">提交</div>
						<div v-if="testDetailList[act].bingo&&act!=testDetailList.length-1" @click="nextTi" class="submit">下一题</div>
						<div @click="beforeTi" v-if="act!=0" class="before">上一题</div>
					</div>
					<div class="jiexi" v-if="testDetailList[act].bingo">
						<div class="jiexi-title">
							<div :class="testDetailList[act].yourAnswer==testDetailList[act].realAnswer?'jiexi-title-t':'jiexi-title-f'">你的选择:{{testDetailList[act].yourAnswer}}</div>
							<div class="jiexi-title-t">正确答案:{{testDetailList[act].realAnswer}}</div>
						</div>
						<!-- <div class="jiexi-label">解析:</div> -->
						<div class="jiexi-text">
							<MarkdownMath :content="testDetailList[act].explain||testDetailList[act].parse"></MarkdownMath>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>
<script>
import MarkdownMath from '../components/MarkdownMath.vue';
export default {
	name: 'index',

	components: {MarkdownMath},

	data(){
		return {
			userInfo:JSON.parse(localStorage.getItem('userInfo')),
			testDetailList:[],
			act:0,
			startTime: null, // 开始时间
		}
	},

	created(){
		this.getTestDetailList();
		this.query = this.$route.query
	},
	beforeDestroy() {
		this.getWeaknessSubmit(false);
	},
	mounted() {
		// 记录进入页面的时间
		this.startTime = new Date();
	},

	computed: {

	},
	watch: {

	},
	methods: {
		calculateTimeSpent() {
			// 计算停留时间（分钟）
			const timeSpent = (new Date() - this.startTime) / 1000;
			console.log(`页面停留时间：${parseInt(timeSpent)} 秒`);
			return parseInt(timeSpent)
		},
		async getTestDetailList() {
			console.dir(this.userInfo);
			let grades;
			if(localStorage.getItem("schoolType")){
				grades = localStorage.getItem("schoolType") === "C" ? '初中' : '高中';
			}
			let jsondata = {
				point_id:this.$route.query.id,
				phone:this.userInfo.accountCode,//手机号
				subject:this.$route.query.subject,//学科
				city:this.userInfo.cityId,//城市
				school:this.userInfo.schoolId,//学校
				level:grades||this.userInfo.gradeClass.split("/")[0],//年级
				pid:"w7398uoaiIAF98wu",//pid
				status:[],
			};
			const res = await this.$api.getPracticeList(jsondata);
			if (res.data.code === 0) {
				this.testDetailList = res.data.data;
				this.getWeaknessPractise();
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		beforeTi(){
			this.act--;
			this.getWeaknessSubmit(false);//上一题只提交时间
		},
		nextTi(){
			this.act++;
			this.getWeaknessSubmit(false);//下一题只提交时间
		},
		checkTi(index){
			this.act = index;
			this.getWeaknessSubmit(false);//切换题只提交时间
		},
		abcd(i){
			if(i==0){
				return 'A'
			}else if(i==1){
				return 'B'
			}else if(i==2){
				return 'C'
			}else if(i==3){
				return 'D'
			}
		},
		checkItem(item){
			for(let ite of this.testDetailList[this.act].answer_list){
				ite.check = false;
			}
			item.check = true;
			this.$forceUpdate()
		},
		submit(){
			console.dir(this.testDetailList[this.act].answer_list);
			let yourAnswer,realAnswer,explain;
			for(let i in this.testDetailList[this.act].answer_list){
				if(this.testDetailList[this.act].answer_list[i].check){
					yourAnswer = this.abcd(i);
					explain = this.testDetailList[this.act].answer_list[i].explain;
				}
				if(this.testDetailList[this.act].answer_list[i].isAnswer){
					realAnswer = this.abcd(i);
				}
			}
			if(!yourAnswer){
				this.$message.error("请选择选项");
				return;
			}
			this.testDetailList[this.act].bingo = yourAnswer == realAnswer?1:2;
			this.testDetailList[this.act].yourAnswer = yourAnswer;
			this.testDetailList[this.act].realAnswer = realAnswer;
			this.testDetailList[this.act].explain = explain;
			this.$forceUpdate();
			console.dir(this.testDetailList)
			this.calculateAccuracy();
			this.getWeaknessSubmit(true);//提交题时间和答案
		},
		goBack(){
			this.$router.back()
		},
		calculateAccuracy() {
		  if (!this.testDetailList || this.testDetailList.length === 0) {
		    return '0.00%';
		  }
		  const total = this.testDetailList.length;
		  const bingoCount = this.testDetailList.filter(item => item.bingo === 1).length;
		  const accuracy = (bingoCount / total) * 100;
		  console.dir(accuracy)
		  return accuracy.toFixed(2) + '%';
		},
		async getWeaknessPractise() {
			let jsondata = {
				pointId:this.$route.query.id,
				subject:this.$route.query.subject,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type: 2,
			};
			const res = await this.$api.getWeaknessPractise(jsondata);
			if (res.data.success) {
				this.testDetailList.forEach(testItem => {
				  res.data.data.forEach(resItem => {
				    if (resItem.businessId == testItem.id) {
				      testItem.bingo = resItem.bingo;
				      testItem.yourAnswer = resItem.yourAnswer;
				      testItem.realAnswer = resItem.realAnswer;
				      testItem.explain = resItem.explain;
							// 遍历 resItem.answer_list
							testItem.answer_list.forEach((answer, i) => {
								if (resItem.yourAnswer === this.abcd(i)) {
									answer.check = true;  // 如果匹配，设置 testItem.check 为 true
								}
							});		
				    }
				  });
				});
				this.$forceUpdate();
				console.log('this.testDetailList',this.testDetailList)
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getWeaknessSubmit(status) {
			let jsondata = {
				pointId:this.$route.query.id,
				pointName:this.$route.query.point_name,
				businessId: this.testDetailList[this.act].id,
				businessName: this.testDetailList[this.act].name,
				subject:this.$route.query.subject,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type: 2,
				bingo: status?this.testDetailList[this.act].bingo:0,
				yourAnswer: status?this.testDetailList[this.act].yourAnswer:'',
				realAnswer: status?this.testDetailList[this.act].realAnswer:'',
				explain: status?this.testDetailList[this.act].explain||this.testDetailList[this.act].parse:'',
				operaLongTime: ""+this.calculateTimeSpent(),
				completeStatus:status,
			};
			const res = await this.$api.getWeaknessSubmit(jsondata);
			if (res.data.success) {
				let allCompleted = true;
				this.testDetailList.forEach((courseItem, index) => {
				  if (!courseItem.bingo) {
				    allCompleted = false;
				  }
				});
				
				// 如果所有其他子项的 isCompleted 都为 true，则调用 complete() 方法
				if (allCompleted) {
				  this.getLearnComplete();
				}
				console.dir('上传学习记录完成')
				this.startTime = new Date();
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		//学习知识点完结操作
		async getLearnComplete(){
			let jsondata = {
				pointId:this.query.id,
				subject:this.query.subject,//学科
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:2,//练习
			};
			const res = await this.$api.getLearnComplete(jsondata);
			if (res.data.success) {
				localStorage.setItem('testHot',true);
				this.$message.success('该知识点练习已全部作答');
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.test-detail{
	padding: 1.5rem 2rem 2rem;
	.back{
		display: flex;
		font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
		font-weight: 500;
		font-size: 1.6rem;
		color: rgba(0,0,0,0.8);
		line-height: 1.88rem;
		margin-bottom: 1.5rem;
		text-align: left;
		img{
			width: 1.85rem;
			height: 1.85rem;
			transform: rotate(180deg);
		}
	}
	.test-main{
		display: flex;
		.test-info{
			width: 24.35rem;
			height: 51rem;
			background: #FFFFFF;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			margin-right: 1.5rem;
			padding: 1.5rem;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			.point-label{
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.6rem;
				color: #000000;
				line-height: 1.7rem;
				margin-bottom: 1.5rem;
			}
			.point{
				display: flex;
				margin-bottom: 1rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				color: rgba(0,0,0,0.7);
				line-height: 1.7rem;
				.point-name{
					color: rgb(100, 45, 113);
					font-weight: bold;
				}
			}
			.point-num{
				display: flex;
				margin-bottom: 1rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				color: rgba(0,0,0,0.7);
				line-height: 1.7rem;
				.num{
					color: #00D215;
					font-weight: bold;
				}
			}
			.point-info{
				width: 21.35rem;
				height: 16.65rem;
				background: #F8F9FB;
				border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
				padding: 1rem;
				box-sizing: border-box;
				margin-bottom: 2.25rem;
				.point-info-label{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 500;
					font-size: 1.2rem;
					color: #000000;
					line-height: 2rem;
				}
				.point-info-text{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 400;
					font-size: 1.2rem;
					color: rgba(0,0,0,0.7);
					line-height: 1.7rem;
				}
			}
			.point-list{
				display: flex;
				flex-wrap: wrap;
				gap: 1.1rem;
				height: 20rem;
				overflow: auto;
				.point-item{
					width: 2.1rem;
					height: 2rem;
					background: #F8F9FB;
					border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
					border: 0.05rem solid #E0E0E0;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1rem;
					color: #1D1D1D;
					display: flex;
					justify-content: center;
					align-items: center;
					box-sizing: border-box;
				}
				.point-item-t{
					background: #00D215;
					color: #fff;
				}
				.point-item-f{
					background: #FD0000;
					color: #fff;
				}
				.point-item-act{
					border: 3px solid #409EFF;
					box-sizing: border-box;
				}
			}
			.point-legend{
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: auto;
				.point-legend-cont{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1rem;
					color: #000000;
					display: flex;
					margin: 0 1.13rem;
					.point-legend-icon{
						width: 1.2rem;
						height: 1.2rem;
						border-radius: 0rem 0rem 0rem 0rem;
						margin-right: 0.6rem;
					}
					.point-legend-icon-no{
						background: #F8F9FB;
						border: 0.05rem solid #E0E0E0;
					}
					.point-legend-icon-t{
						background: #00D215;
						border: 0.05rem solid #00D215;
					}
					.point-legend-icon-f{
						background: #FF0B0B;
						border: 0.05rem solid #FF0B0B;
					}
				}
			}
		}
		.test-list{
			width: 70.15rem;
			height: 51rem;
			background: #FFFFFF;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			padding: 5rem;
			box-sizing: border-box;
			overflow-x: hidden;
			overflow-y: auto;
			.question{
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.8rem;
				color: #000000;
				margin-bottom: 3rem;
				display: flex;
				span{
					margin-right: 1rem;
				}
			}
			.answer-list{
				margin-bottom: 4rem;
				.answer-item{
					display: flex;
					align-items: center;
					margin-bottom: 2.5rem;
					font-family: PingFang SC, PingFang SC;
					font-size: 1.6rem;
					color: #303030;
					.answer-text{
						display: flex;
						span{
							margin-right: 1rem;
						}
					}
					.answer-icon{
						width: 1.6rem;
						height: 1.6rem;
						background-repeat: no-repeat;
						background-size: 100% 100%;
						margin-right: 1rem;
						background-image: url(../assets/answer-n.png);
					}
					.answer-icon-act{
						background-image: url(../assets/answer-y.png);
					}
					.answer-icon-true{
						background-image: url(../assets/answer-true.png);
					}
					.answer-icon-false{
						background-image: url(../assets/answer-false.png);
					}
				}
			}
			.btn-group{
				display: flex;
				.before{
					margin-left: 1rem;
					width: 8.4rem;
					height: 2.9rem;
					background: #fff;
					border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 500;
					font-size: 1.4rem;
					color: #000;
					border:1px solid #ccc;
					line-height: 2.9rem;
					text-align: center;
					margin-bottom: 2rem;
				}
			}
			.submit{
				width: 8.4rem;
				height: 2.9rem;
				background: rgb(100, 45, 113);
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.4rem;
				color: #FFFFFF;
				line-height: 2.9rem;
				text-align: center;
				margin-bottom: 2rem;
			}
			.jiexi{
				width: 61.15rem;
				// height: 12.4rem;
				// overflow: auto;
				background: #F8F9FB;
				border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
				padding: 1.5rem 2rem;
				box-sizing: border-box;
				.jiexi-title{
					display: flex;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 500;
					font-size: 1.6rem;
					line-height: 1.88rem;
					margin-bottom: 1rem;
					.jiexi-title-f{
						color: #FD0000;
						margin-right: 2.5rem;
					}
					.jiexi-title-t{
						color: #00DE16;
						margin-right: 2.5rem;
					}
				}
				.jiexi-label{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 500;
					font-size: 1.2rem;
					color: #000000;
					line-height: 2rem;
				}
				.jiexi-text{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1.2rem;
					color: #000000;
					line-height: 1.7rem;
				}
			}
			// <div class="jiexi">
			// 	<div class="jiexi-title">
			// 		<div class="jiexi-title-f">你的选择:C</div>
			// 		<div class="jiexi-title-t">正确答案:B</div>
			// 	</div>
			// 	<div class="jiexi-label"></div>
			// 	<div class="jiexi-text"></div>
			// </div>
		}
	}
}
</style>
